module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InNjYWxlKC40ODIgLjcyKSIgc3Ryb2tlLXdpZHRoPSIxcHQiPgogICAgPHJlY3Qgcng9IjAiIHJ5PSIwIiBoZWlnaHQ9IjcwOC42NiIgd2lkdGg9IjEwNjMiLz4KICAgIDxyZWN0IHJ4PSIwIiByeT0iMCIgaGVpZ2h0PSIyMzYuMjIiIHdpZHRoPSIxMDYzIiB5PSI0NzUuNTYiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGZpbGw9IiMxMjkxZmYiIGQ9Ik0wIDBoMTA2M3YyMzYuMjJIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ee.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ee.svg
// module chunks = 0